// extracted by mini-css-extract-plugin
export default {"wrapperHomePage":"Home_wrapperHomePage__FBp8w"};